import { render, staticRenderFns } from "./personalInformation.vue?vue&type=template&id=4ea44530&scoped=true&"
import script from "./personalInformation.vue?vue&type=script&lang=ts&"
export * from "./personalInformation.vue?vue&type=script&lang=ts&"
import style0 from "./personalInformation.vue?vue&type=style&index=0&id=4ea44530&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea44530",
  null
  
)

export default component.exports